import React from 'react'
import moment from 'moment'

import GridElementContainer from '../../GridElementContainer'
import Icon from 'components/UI/Icon'
import Button from 'components/UI/Button'

import { Avatar } from '../../../../../UI'
import { getUserName } from '../../../../../../helpers'

const NextClass = ({ nextClass, className = '', containerClassName = '' }) => {
  const userName = nextClass
    ? getUserName(
        nextClass.student_details,
        nextClass.student_details?.display_name,
        nextClass.student_details?.student_last_name,
        {
          usernameKey: 'student_username',
          firstNameKey: 'student_first_name',
          lastNameKey: 'student_last_name',
        }
      )
    : ''
  const hour = parseFloat(nextClass?.booking_slot)

  return (
    <GridElementContainer className={containerClassName} title="Next Class">
      {nextClass ? (
        <div
          className={`${className} w-full flex flex-col items-start justify-start !border border-primary-450 p-[10px] rounded-md`}
        >
          <h3 className="text-primary-100 text-2xl font-bold !mb-2">
            {nextClass.class_banner_details.class_banner_category}
          </h3>

          <div className="flex flex-col w-full items-start jutify-start">
            <div className="flex items-start justify-between w-full !mb-2">
              <div className="flex items-center justify-start flex-1">
                <div className="mr-[10px]">
                  <Icon width={16} height={16} color="#F67443" name="calendar" />
                </div>
                <span className="text-primary-75">Date & Time</span>
              </div>
              <div className="flex-1">
                <p className="text-primary-100 text-right font-semibold">
                  {moment(nextClass.booking_date).format('MMMM DD, YYYY')}
                  <br />
                  {moment(
                    `${nextClass.booking_date} ${hour < 10 && hour > -1 ? `0${hour}` : hour}:00`
                  ).format('hh a')}
                </p>
              </div>
            </div>
            <div className="flex items-center justify-between w-full !mb-2">
              <div className="flex items-center justify-start flex-1">
                <div className="mr-[10px]">
                  <Icon width={16} height={16} color="#F67443" name="book" />
                </div>
                <span className="text-primary-75">Classes Taken Previosuly</span>
              </div>
              <div className="">
                <p className="text-primary-100 text-right font-semibold">
                  {nextClass.class_before_count || 0}
                </p>
              </div>
            </div>
            <div className="flex items-center justify-between w-full !mb-2">
              <div className="flex items-center justify-start">
                <div className="mr-[10px]">
                  <Icon width={16} height={16} color="#F67443" name="user" />
                </div>
                <span className="text-primary-75">Student</span>
              </div>
              <div className="flex-1 flex justify-end">
                <div className="flex items-center justify-end">
                  <Avatar
                    className="w-[36px] h-[36px] !mr-2"
                    src={nextClass.student_details.student_profile_picture || ''}
                    alt={userName}
                  />

                  <span className="w-[70%] text-primary-100 text-right font-semibold text-ellipsis whitespace-nowrap overflow-hidden">
                    {userName}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-betwen gap-x-[10px] w-full">
              <Button className="flex-1 py-[6px]">Message</Button>
              <Button
                className="flex-1 !bg-white py-[6px] hover:!bg-primary-button-hover hover:!border-primary-button-hover hover:!text-white"
                variant="secondary"
              >
                See Profile
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-full p-[10px] flex items-center justify-center flex-col border-[1px] border-[#FFCA84] rounded-[6px]">
          <img
            src="/assets/icon/empty-next-class.svg"
            alt="Empty next class"
            className="w-[124px] h-[124px]"
          />

          <p className="text-[20px] leading-[29px] text-primary-100 font-bold mt-[10px] text-center">
            Your Next Class Will Appear Here
          </p>
        </div>
      )}
    </GridElementContainer>
  )
}

export default NextClass
